"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TOPIC;
(function (TOPIC) {
    TOPIC[TOPIC["UNKNOWN"] = 0] = "UNKNOWN";
    TOPIC[TOPIC["PARSER"] = 1] = "PARSER";
    TOPIC[TOPIC["CONNECTION"] = 2] = "CONNECTION";
    TOPIC[TOPIC["AUTH"] = 3] = "AUTH";
    TOPIC[TOPIC["EVENT"] = 4] = "EVENT";
    TOPIC[TOPIC["RECORD"] = 5] = "RECORD";
    TOPIC[TOPIC["RPC"] = 6] = "RPC";
    TOPIC[TOPIC["PRESENCE"] = 7] = "PRESENCE";
    TOPIC[TOPIC["MONITORING"] = 8] = "MONITORING";
    TOPIC[TOPIC["CLUSTER"] = 9] = "CLUSTER";
    TOPIC[TOPIC["LOCK"] = 10] = "LOCK";
    TOPIC[TOPIC["STATE_REGISTRY"] = 11] = "STATE_REGISTRY";
    TOPIC[TOPIC["ERROR"] = 100] = "ERROR";
})(TOPIC = exports.TOPIC || (exports.TOPIC = {}));
//# sourceMappingURL=general.js.map